/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $form from './_form'
import * as $msg from './_msg'
import { flagsChanged } from './flag.edit'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    myFlags: boolean
}

export function init($options: IInitOptions): void {
    ;(function (options) {
        initClosure(options)
    })($.extend(true, {}, $options))
}

function initClosure(options: IInitOptions): void {
    var defaultColor: string = '#808080'

    if (options.myFlags) {
        $('.' + options.pagePrefix + '-color-tb').on('keyup', function () {
            var tb = $(this)
            var val = tb.val()
            if (!/^#[0-9a-f]{6}$/.test(val) && !/^#[0-9a-f]{3}$/.test(val)) val = defaultColor
            tb.css('background-color', val)
        })

        $('.' + options.pagePrefix + '-btn-delete').click(function () {
            var btn = $(this)
            const flagId = parseInt(btn.attr('data-id'))
            deleteFlag(flagId, options)
        })

        $('.' + options.pagePrefix + '-name-tb').each(function () {
            var tb = $(this)
            var id = parseInt(tb.attr('data-id'))

            var func = _.debounce(function () {
                saveFlag(id, options)
            }, 500)

            tb.on('keyup', func)
            tb.on('blur', func)

            $('#' + options.pagePrefix + '-color-tb-' + id).on('keyup', func)
            $('#' + options.pagePrefix + '-color-tb-' + id).on('blur', func)

            $('#' + options.pagePrefix + '-sort-tb-' + id).on('keyup', func)
            $('#' + options.pagePrefix + '-sort-tb-' + id).on('blur', func)

            $('#' + options.pagePrefix + '-hidden-rbl-' + id + ' .btn').on('click', () => {
                hideFlag(id, options)
            })
            $('#' + options.pagePrefix + '-hidden-rbl-' + id + ' .btn').on('change', () => {
                hideFlag(id, options)
            })

            $('#' + options.pagePrefix + '-shared-rbl-' + id + ' .btn').on('click', func)
            $('#' + options.pagePrefix + '-shared-rbl-' + id + ' .btn').on('change', func)
        })

        $('.' + options.pagePrefix + '-color-tb').each(function () {
            var tb = $(this)
            var id = parseInt(tb.attr('data-id'))
            tb.popover({
                content:
                    '<div class="' +
                    options.pagePrefix +
                    '-color-picker ' +
                    options.pagePrefix +
                    '-color-picker-' +
                    id +
                    '">Laddar färgväljaren...</div>',
                html: true,
                placement: 'auto top',
                trigger: 'focus',
            }).on('shown.bs.popover', function () {
                $('.' + options.pagePrefix + '-color-picker-' + id).minicolors({
                    inline: true,
                    defaultValue: tb.val(),
                    changeDelay: 500,
                    change: function (hex: string) {
                        //, opacity
                        tb.val(hex)
                        tb.css('background-color', hex)
                        saveFlag(id, options)
                    },
                })
            })
        })

        $('.' + options.pagePrefix + '-expando').click(function () {
            var id = $(this).attr('data-id')
            var row1 = $('.' + options.pagePrefix + '-tr-' + id)
            var row2 = $('.' + options.pagePrefix + '-tr2-' + id)

            row1.find('.' + options.pagePrefix + '-expando-icon').toggleClass('fa-chevron-right')
            row1.find('.' + options.pagePrefix + '-expando-icon').toggleClass('fa-chevron-down')
            row2.toggleClass('bcfla-hidden')

            setTimeout(function () {
                if (!row2.hasClass('bcfla-hidden')) {
                    $ajax.post({
                        loadingText: 'Laddar...',
                        url: '/Flag/ListSharesForFlag',
                        data: {
                            flagId: id,
                        },
                        dataType: 'html',
                        success: function (res) {
                            row2.find('.' + options.pagePrefix + '-tr2-content').html(res)
                        },
                    })
                }
            }, 200)
        })
    }

    $('.' + options.pagePrefix + '-expand-agare').click(function () {
        var icon: JQuery = $(this)
        var id: string = icon.attr('data-id')
        var tr: JQuery = $('.' + options.pagePrefix + '-expanded-agare-' + id)

        if (icon.hasClass('fa-chevron-right')) {
            icon.removeClass('fa-chevron-right')
            icon.addClass('fa-chevron-down')
            tr.removeClass('bcfla-hidden')
        } else {
            icon.addClass('fa-chevron-right')
            icon.removeClass('fa-chevron-down')
            tr.addClass('bcfla-hidden')
        }
    })

    flagsChanged()
}

function deleteFlag(id: number, options: IInitOptions): void {
    $ajax.post({
        loadingText: 'Kontrollerar...',
        url: '/Flag/ShouldDelete',
        data: {
            id: id,
        },
        success: function (res) {
            let warning = 'Är du säker på att du vill radera denna flagga?'
            if (!res.Ok && res.Message) warning += ' Den används i följande sparade sökfrågor: ' + res.Message

            if (confirm(warning)) {
                $ajax.post({
                    loadingText: 'Raderar...',
                    url: '/Flag/Delete',
                    data: {
                        id: id,
                    },
                    success: function () {
                        $('.' + options.pagePrefix + '-tr-' + id).fadeOut(300, function () {
                            $('.' + options.pagePrefix + '-tr-' + id).remove()
                            setTimeout(flagsChanged, 500)
                        })
                    },
                })
            }
        },
    })
}

function saveFlag(id: number, options: IInitOptions): void {
    const name: string = $('#' + options.pagePrefix + '-name-tb-' + id).val()

    $ajax.post({
        loadingText: 'Sparar...',
        url: '/Flag/Save',
        data: {
            flagId: id,
            name: name,
            color: $('#' + options.pagePrefix + '-color-tb-' + id).val(),
            sort: $('#' + options.pagePrefix + '-sort-tb-' + id).val(),
            shared: $form.getCheckboxlistValues($('#' + options.pagePrefix + '-shared-rbl-' + id)).join(','),
        },
        success: function (res) {
            if (res.Ok) $msg.show(`Flaggan ${name} har sparats!`)
            else $msg.showError(res.Message)
            setTimeout(flagsChanged, 500)
        },
    })
}

function hideFlag(id: number, options: IInitOptions): void {
    const name: string = $('#' + options.pagePrefix + '-name-tb-' + id).val()

    $ajax.post({
        loadingText: 'Sparar...',
        url: '/Flag/SetFlagHidden',
        data: {
            flagId: id,
            hidden: $form.getCheckboxlistValues($('#' + options.pagePrefix + '-hidden-rbl-' + id)).join(','),
        },
        success: function (res) {
            if (res.Ok) $msg.show(`Flaggan ${name} har sparats!`)
            else $msg.showError(res.Message)
            setTimeout(flagsChanged, 500)
        },
    })
}
